class environment {
  static production = true;
  static generalSettings = false;
  static ApplicationBaseName = "/";
  static ApplicationURL = `https://fiscal.dcgary.org${environment.ApplicationBaseName}`;
  static ApplicationName = 'fiscal';
  static tenant = "865064fd-4748-46b9-96b2-29e635efb924";
  static scope = "api://dcgary.org/FISCAL/Access_as_users";
  static documentEnvironment = "uat/";
  static session_timeout_duration = 24 * 60 * 60 * 1000;
  static clientName = "DC Gary";

  static environmentBaseUrl = 'https://fiscal.dcgary.org/';
  static baseUrl = `${environment.environmentBaseUrl}fiscal-services/api/v1.0/`;
  static budgetBaseUrl = `${environment.environmentBaseUrl}budget-services/api/v1.0/`;

  static clientId = "3166e1f2-23d9-40f6-8ae1-adb8a834bc21";
  static blackBaudClientId = "e77a3406-145f-48ab-baaa-246898be2388";
  static aadSecureAuthority = `${environment.environmentBaseUrl}auth-services/api/v1.0/secure/auth/user-info?authority=`;
  static refresh_tocken_base_url = `${environment.environmentBaseUrl}auth-services/api/v1.0/secure/auth/token/refresh`;
  static azureNewUser = `${environment.baseUrl}users/azure`;
  static updateClientConfigurationSettings = `${environment.baseUrl}client/`;

  // QuickBooks Online (QBO) Integration  
  static qboConnectionSetupURL = `${environment.baseUrl}qbo-connection/setup/`;
  static qboConnectionParticipantConfiguredURL = `${environment.baseUrl}qbo-connection/is-participant-configured/`;
  static postParticipantExternalSystemConfigURL = `${environment.baseUrl}participant-external-system-config/`;
  static updateParticipantExternalSystemConfigURL = `${environment.baseUrl}participant-external-system-config/`;
  static getParticipantExternalSystemConfigURL = `${environment.baseUrl}participant-external-system-config/`;
  static postQuickBooksLogFilter = `${environment.baseUrl}dnl-qbo-trans-log/filter`;

  //  BlackBaud Integration
  static postBlackBaudLogFilter = `${environment.baseUrl}black-baud-trans-log/filter`;
  static postBlackBaudTransactionLogFilter = `${environment.baseUrl}external-batch/filter`;
  static getBlackBaudDetailsByEventTypeAndInternalIdURL = `${environment.baseUrl}external-batch/transaction-date?transactionDate=`;
  static postReProcessBlackBaudTransactionURL = `${environment.baseUrl}bb-je-transaction/reprocess?transactionDate=`;
  static postBlackBaudAuthCode = `${environment.baseUrl}bb-auth/setup/code/`;
  static getBlackBaudAuthCode = `${environment.baseUrl}bb-auth/validate`;
  static BlackBaudRedirectUrl = `${environment.environmentBaseUrl}?source=blackbaud`;

  static getUsersDeatailsByMail = `${environment.baseUrl}users/mail/`;
  static getAllRoles = `${environment.baseUrl}roles/all`;
  static fiscalBaseURL = `${environment.baseUrl}`;
  static postNewFund = `${environment.baseUrl}funds/`;
  static getUserDetails = `${environment.baseUrl}users/filter`;
  static postSaveNewParticipant = `${environment.baseUrl}participants`;
  static getFundSource = `${environment.baseUrl}funds/filter`;
  static getAuditDetails = `${environment.baseUrl}fund-audit-log/filter`;
  static getAllRolesDetailsURL = `${environment.baseUrl}roles/all`;
  static deleteUserURL = `${environment.baseUrl}users/`;
  static postTranferFunds = `${environment.baseUrl}funds/transfer`;
  static getFundTransactionHistory = `${environment.baseUrl}fund-transaction-history`;
  static patchFundDetails = `${environment.baseUrl}funds`;
  static getFundAuditHistory = `${environment.baseUrl}fund-audit-log`;
  static getGlAssetsummary = `${environment.baseUrl}master-transactions/gl-assets-summary/participant/`;
  static assetSummaryByPID = `${environment.baseUrl}master-transactions/gl-assets-summary/participant/`;
  static capitalSummaryByPID = `${environment.baseUrl}master-transactions/gl-revenue-summary/participant/`;
  static expensesSummaryByPID = `${environment.baseUrl}gl-accounts/expense-summary/participant/`;
  static loanSummaryByPID = `${environment.baseUrl}loan/gl-liabilities-summary/participant/`;
  static assetRCBOSummary = `${environment.baseUrl}master-transactions/gl-assets-summary`;
  static loanRcboSummary = `${environment.baseUrl}loan/gl-liabilities-summary`;
  static capitalRcboSummary = `${environment.baseUrl}master-transactions/gl-global-revenue-summary`;
  static expensesSummary = `${environment.baseUrl}gl-accounts/expense-summary`;
  static systemSettingsURL = `${environment.baseUrl}system-settings`;
  static postSystemSettingsURL = `${environment.baseUrl}system-settings/`;
  static bankDetailsSummaryByPidURL = `${environment.baseUrl}transaction-summary/bank-summary/`;
  static transactionSummaryDetailsURL = `${environment.baseUrl}transaction-summary/account-summary/`;
  static getMasterTransactionURL = `${environment.baseUrl}master-transactions/filter`;
  static masterTransNotesURL = `${environment.baseUrl}master-transactions/`;
  static getCheckImageDigerTech = `${environment.baseUrl}diger-tech/check-image`;
  static downloadFileURL = `${environment.baseUrl}master-transactions/export`;
  static menuItemsURL = `${environment.baseUrl}permission`;

  //Master Transaction Manual Entries
  static masterTransactionManualEntriesURL = `${environment.baseUrl}master-transactions/`;
  static postFundTransactionHistoryManual = `${environment.baseUrl}fund-transaction-history/manual/`;
  static postInvoiceTransactionHistoryManual = `${environment.baseUrl}manual-invoice-transaction/`;
  static postInvoiceTransactionHistoryManualFilter = `${environment.baseUrl}manual-invoice-transaction/filter`;
  static deleteInvoiceTransactionHistoryManual = `${environment.baseUrl}manual-invoice-transaction/`;
  static postCreditlineManualTransaction = `${environment.baseUrl}creditline/manual/transaction`;
  static getDateForACreditlineTransaction = `${environment.baseUrl}creditline/`;
  static getDateForAFundTransaction = `${environment.baseUrl}funds/`;


  //Theme settings
  static postThemURL = `${environment.baseUrl}theme-settings/`;

  //LOANS
  static postNewLoan = `${environment.baseUrl}loan/`;
  static postLoanFilter = `${environment.baseUrl}loan/filter`;
  static postLoanHistory = `${environment.baseUrl}loan-transaction-history/filter`;
  static getLoanLatestHistory = `${environment.baseUrl}loan-transaction-history/loan`;
  static getListOfPreviousMonthsURL = `${environment.baseUrl}utility/previous-months/`;
  static postDocuments = `${environment.baseUrl}documents/entity/`;
  static getDocumentsById = `${environment.baseUrl}documents/filter`;
  static downloadDocuments = `${environment.baseUrl}documents/read?filePath=`;
  static deleteDocuments = `${environment.baseUrl}documents/`;

  // Download all documents for modules, loans, invoices, etc.
  static getDownloadDocumentsById = `${environment.baseUrl}documents/download/`;

  //Reports
  static getClientStatementPDF = `${environment.baseUrl}report/client-statement-pdf/`;
  static getParticipantStatementPDF = `${environment.baseUrl}report/download`;

  //Special Payments History (Admin)
  static getSpecialCollectionHistory = `${environment.baseUrl}special-collection-history/filter`;
  static submitReversalRequest = `${environment.baseUrl}special-collection-history/reversal-request?netsuiteJournalEntryId`;
  static reversalApprovalAndReject = `${environment.baseUrl}special-collection-history/reversal-request/approve-or-reject`;


  //   MonthlyCalculations
  static postMonthlyCalculationsList = `${environment.baseUrl}monthly-batch-log/filter`;
  static postParticipants = `${environment.baseUrl}participants/filter`;
  static monthlyCalculationsByPID = `${environment.baseUrl}monthly-batch-log/entity-names/participant`;
  static getMonthsList = `${environment.baseUrl}monthly-batch-log/calculations`;
  static savingsIntrestRate = `${environment.baseUrl}funds`;
  static checkingIntrestRate = `${environment.baseUrl}master-transactions/interest-calculation/checking`;
  static postCheckingIntrestRate = `${environment.baseUrl}master-transactions/monthly-checking-statements/by-period`;
  static creditLineIntrestRate = `${environment.baseUrl}creditline`;
  static getAllEntityIntrestRate = `${environment.baseUrl}interest/`;
  static postAllEntityIntrestRate = `${environment.baseUrl}interest/post-external-system`;

  //  AutoDebit
  static postAutoDebitsList = `${environment.baseUrl}loan/auto-debit/filter`;
  static loanDetailsByPID = `${environment.baseUrl}loan/participant`;
  static loanDatesByLoanId = `${environment.baseUrl}loan`;
  static loanSourceByPID = `${environment.baseUrl}master-transactions/gl-assets-summary/participant`;
  static saveAutoDebit = `${environment.baseUrl}loan/auto-debit/`;
  static deleteAutoDebit = `${environment.baseUrl}loan/auto-debit/`;

  //RCBOInvoice
  static getAllParticipants = `${environment.baseUrl}participants/filter`;
  static postRcboInvoiceList = `${environment.baseUrl}ns-invoice/rcbo/filter`;
  static saveMakePayment = `${environment.baseUrl}invoice/rcbo-make-payment/`;
  static getRCBOSourceListByPid = `${environment.baseUrl}invoice/payment-accounts`;


  //CreditLines
  static postCreditLinesList = `${environment.baseUrl}creditline/filter`;
  static creditBalanceByPid = `${environment.baseUrl}loan/gl-liabilities-summary/participant`;
  static postNewCreditLine = `${environment.baseUrl}creditline/`;
  static saveCreditMakePayment = `${environment.baseUrl}creditline/payment`;
  static getCreditLineAmountbyCreditId = `${environment.baseUrl}creditline`;
  static postCreditLineClosureAndLoanMerge = `${environment.baseUrl}creditline/close-and-transfer`;

  //Invoice
  static getVendorList = `${environment.baseUrl}ns-vendor/filter/vendor-name/`;
  static getInvNumberByVendorName = `${environment.baseUrl}invoice/numbers/vendor/`;
  static postInvoice = `${environment.baseUrl}invoice/`;
  static putRefreshNetsuiteStatus = `${environment.baseUrl}ns-invoice/refresh-netsuite-invoice-status/participant/`;
  static getTaskDetailsByInvoiceIdURL = `${environment.baseUrl}task/invoice/`;
  static sendTaskReminderApprovalMailURL = `${environment.baseUrl}email/invoices/`;
  static getTaskApprovalByTaskIdMailURL = `${environment.baseUrl}task-approver/`;

  // Audit log
  static postAuditFilter = `${environment.baseUrl}audit-log/filter`;
  static getAuditEvent = `${environment.baseUrl}audit-log/events`;
  static postAuditLogInandLogOut = `${environment.baseUrl}audit-log/`;

  // NetSuite Log
  static postNetSuiteFilter = `${environment.baseUrl}dnl-netsuite-trans-log/filter`;

  //Project Approver
  static saveParticipantApprover = `${environment.baseUrl}participant-approver/`;
  static getPartiApprByPartIdAndClientId = `${environment.baseUrl}participant-approver/participant/`;
  static getPartApprByIdAndTypeAndClient = `${environment.baseUrl}participant-approver/`;
  static getPartApprByApprIdAndClientId = `${environment.baseUrl}participant-approver`;

  //settings url
  static getSystemSettingsURL = `${environment.baseUrl}system-settings?attributeName=`;
  static updateLoanGracePeriodURL = `${environment.baseUrl}loan/update?gracePeriod=`;
  static saveSystemSettingsURL = `${environment.baseUrl}system-settings/grace-period/`;

  //client-test-config url
  static updateTodayDateByCIdURL = `${environment.baseUrl}client-test-config/update?value=`;
  static getClientTestConfigTodayDate = `${environment.baseUrl}client-test-config/today-date?key=`;

  //workflow settings
  static saveInvoiceTaskProperties = `${environment.baseUrl}invoice-task-properties/`;
  static getAllInvoiceTaskProperties = `${environment.baseUrl}invoice-task-properties/all?`;
  static getInvoiceTaskPropertiesByType = `${environment.baseUrl}invoice-task-properties?`;

  // participant interest rate
  static fetchParticipantInterestListURL = `${environment.baseUrl}participant-interest-rates/participants/filter`;
  static createParticipantInterestURL = `${environment.baseUrl}participant-interest-rates/participants/`;
  static getparticipantsNotInInterestRates = `${environment.baseUrl}participants/filter`;
  static deleteParticipantInterest = `${environment.baseUrl}participant-interest-rates/participants/`;
  static getParticipantInterestDetailsById = `${environment.baseUrl}participant-interest-rates/participants/interest-rates/`;

  // Gl Adjustments
  static postGLAdjustmentRequestsFilter = `${environment.baseUrl}gl-adjustment-requests/`;
  static postAdminGLApproval = `${environment.baseUrl}gl-adjustment-requests/approval`;
  static deleteGLAdjustmentRequests = `${environment.baseUrl}gl-adjustment-requests`;
  static processGLAdjustment = `${environment.baseUrl}gl-adjustment-requests/process/`;
  static preProcessGLAdjustment = `${environment.baseUrl}gl-adjustment-requests/re-process`;
  static getGLAdjustmentById = `${environment.baseUrl}gl-adjustment-requests`;

  //vendor Invoice
  static getVendorSummaryListURL = `${environment.baseUrl}invoice/filter`;
  static getTaskSummaryListURL = `${environment.baseUrl}task/filter`;
  static getVendorInvoiceByInvoiceId = `${environment.baseUrl}invoice/`;
  static getAllVendorInvoiceStatus = `${environment.baseUrl}invoice-status/all?clientId=`;
  static getVendorInvoiceTaskByIdURL = `${environment.baseUrl}task/`;
  static getPaymentAccountsByPIdURL = `${environment.baseUrl}invoice/payment-accounts/`;
  static postPaymentAllocationURL = `${environment.baseUrl}task/approval/`;
  static cancelVendorInvoiceURL = `${environment.baseUrl}invoice/`;
  static saveInvoiceStateHistoryURL = `${environment.baseUrl}invoice-state-history/`;
  static saveTaskApproveReassignURL = `${environment.baseUrl}task-approver/task-reassign?taskId=`;
  static getInvoiceApproversURL = `${environment.baseUrl}invoice/approvers`;
  static getVendorInvoiceActionsById = `${environment.baseUrl}workflow/actions/invoice/`;
  static postNotifyBusinessManager = `${environment.baseUrl}invoice/`;
  static postedToNetSuite = `${environment.baseUrl}invoice/`;
  static postedToCompleteInvoice = `${environment.baseUrl}invoice/`;

  // Special Funds
  static createNewSpecialFund = `${environment.baseUrl}special-collection/`;
  static specialFundApproval = `${environment.baseUrl}special-collection/approval`;
  static getSpecialFundFilter = `${environment.baseUrl}special-collection/filter`;
  static updateSpecialFundFilter = `${environment.baseUrl}special-collection/approval-request/`;
  static postSpecialFundReactivate = `${environment.baseUrl}special-collection/reactivate`;
  static getSpecialCollectionById = `${environment.baseUrl}special-collection`;

  // Special Payments
  static postSpecialPayment = `${environment.baseUrl}master-transactions/transfer-special-fund`;
  static getSpecialPaymentByClientID = `${environment.baseUrl}special-collection/all?clientId=`;
  //budget urls
  static getForcastListURL = `${environment.budgetBaseUrl}forecast-chart-accounts/filter`;
  static getForcastListCountURL = `${environment.budgetBaseUrl}forecast-chart-accounts/count`;
  static getBudgetActualListURL = `${environment.budgetBaseUrl}budget-actual/filter`;
  static getBudgetActualListCountURL = `${environment.budgetBaseUrl}budget-actual/count`;
  static getParticipantForecastStatusListURL = `${environment.budgetBaseUrl}participant-forecast-status/filter`;
  static getParticipantForecastStatusCountURL = `${environment.budgetBaseUrl}participant-forecast-status/count`;
  static getForecastChartAccountsByYearAndParticipantIdURL = `${environment.budgetBaseUrl}forecast-chart-accounts/financial-year/`;
  static getBudgetActualDetailsChartByFinacialYearandMonthURL = `${environment.budgetBaseUrl}budget-actual/`;
  static getBudgetForecastEligibleYearByParticipantIdAndYearURL = `${environment.budgetBaseUrl}budget-forecast-details/eligible-year/participant-id/`;
  static getParticipantActualsStatusByParticipantIdAndFinancialYearAndMonthURL = `${environment.budgetBaseUrl}participant-actual-status/participant-id/`;
  static getParticipantForecastStatusByParticipantIdAndFinancialYearURL = `${environment.budgetBaseUrl}participant-forecast-status/participant-id/`;
  static getAllFinancialYearsUrl = `${environment.budgetBaseUrl}master-chart-accounts/all-financial-years/type/`;
  static getBudgetActualEligibleMonthsByParticipantIdURL = `${environment.budgetBaseUrl}budget-actual-details/quick-book/eligible-months/participant-id/`;
  static getBudgetForecastEligibleYearByParticipantIdURL = `${environment.budgetBaseUrl}budget-forecast-details/quick-book/eligible-year/participant-id/`;
  static getForecastMappingDetailsByFinancialYearAndParticipantIdURL = `${environment.budgetBaseUrl}forecast-chart-accounts/mapping/details/financial-year/`;
  static getForecastMappingDetailsByFinancialYearAndParticipantIdURL1 = `${environment.budgetBaseUrl}fiscal-external-account-system/participant-id/`;
  static getParticipantFileMappingByParticipantIdTypeURL = `${environment.budgetBaseUrl}participant-file-column-mapping/details/participant-id/`;
  static getBudgetActualEligibleMonthsByYearURL = `${environment.budgetBaseUrl}budget-actual-details/eligible-months/`;
  static postParticipantFileMappingURL = `${environment.budgetBaseUrl}participant-file-column-mapping/`;
  static getDetailsByTypeYearURL = `${environment.budgetBaseUrl}cover-sheet-sections/details/year`;
  static getDetailsByYearandLocationIdURL = `${environment.budgetBaseUrl}cover-sheet-actual/details/year`;
  static saveActualDetailsURL = `${environment.budgetBaseUrl}cover-sheet-actual/`;
  static getBRPdfByYearAndLocationURL = `${environment.budgetBaseUrl}cover-sheet-actual/download/year/`;
  static getBudgetDocumentDownloadURL = `${environment.budgetBaseUrl}documents/read?filepath=`;
  static deleteAndRemoveDocumentDetatilsURL = `${environment.budgetBaseUrl}documents/delete`;
  static uploadAndPostDocumentURL = `${environment.budgetBaseUrl}documents/upload`;
  static getDisableFRFieldsURL = `${environment.budgetBaseUrl}budget-actual-details/disable-fr/financial-year/`;
  static getBudgetDocumentDetailsByYearAndLocationIdURL = `${environment.budgetBaseUrl}documents/year/`;
  static getFRPdfByYearAndLocationURL = `${environment.budgetBaseUrl}financial-report-actual/download/year/`;
  static getFinancialReportDetailsByTypeYearURL = `${environment.budgetBaseUrl}financial-report-sections/details/year`;
  static getFinancialReportDetailsByYearandLocationIdURL = `${environment.budgetBaseUrl}financial-report-actual/details/year`;
  static saveFinancialReportActualDetailsURL = `${environment.budgetBaseUrl}financial-report-actual/`;
  static copychartAccountDetailsByYearURL = `${environment.budgetBaseUrl}master-chart-accounts/financial-year`;
  static addMasterChartAccountsURL = `${environment.budgetBaseUrl}master-chart-accounts/`;
  static deleteMasterChartAccountsByIdUrl = `${environment.budgetBaseUrl}master-chart-accounts/`;
  static publishChartAccountDetailsUrl = `${environment.budgetBaseUrl}forecast-chart-accounts/publish/financial-year`;
  static getChartAccountDetailsByYearUrl = `${environment.budgetBaseUrl}master-chart-accounts/financial-year`;
  static deleteSubChartAccountsByIdUrl = `${environment.budgetBaseUrl}master-sub-chart-accounts/`;
  static getParishBudgetFormByFinancialYearURL = `${environment.budgetBaseUrl}parish-budget-form`;
  static getBudgetActualDetailsSubChartByFinacialYearURL = `${environment.budgetBaseUrl}budget-actual-details/sub-chart/`;
  static postForecastChartAccountsTransactionsURL = `${environment.budgetBaseUrl}sub-chart-accounts-transactions/forecast/`;
  static postActualsChartAccountsTransactionsURL = `${environment.budgetBaseUrl}sub-chart-accounts-transactions/actuals/`;
  static postSchoolBudgetFormURL = `${environment.budgetBaseUrl}school-budget-form/`;
  static updateStatusAndForecastSubmissionDateByParticipantIdAndFinancialYearURL = `${environment.budgetBaseUrl}participant-forecast-status/status/`;
  static updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYearAndMonthURL = `${environment.budgetBaseUrl}participant-actual-status/status/`;
  static replaceChartAccountDetailsURL = `${environment.budgetBaseUrl}master-chart-accounts/replace/financial-year`;
  static postFiscalExternalAccountSystemSubChartAccountsTransactionsURL = `${environment.budgetBaseUrl}fiscal-external-account-system/actual`;
  static saveFiscalExternalAccountSystemURL = `${environment.budgetBaseUrl}fiscal-external-account-system/`;
  static postFiscalExternalAccountSystemSubChartAccountsTransactionsForecastURL = `${environment.budgetBaseUrl}fiscal-external-account-system/forecast`;
  static checkForecastChartAccountsExistURL = `${environment.budgetBaseUrl}forecast-chart-accounts/validate`;
  static getBudgetDetailsTODownloadURL = `${environment.budgetBaseUrl}download/budget/financial-year/`;
  static getActualDetailsTODownloadURL = `${environment.budgetBaseUrl}download/actual`;
  static getParticipantActualsExceptionsByParticipantURL = `${environment.budgetBaseUrl}participant-actuals-exceptions/participant/`;
  static postParticipantActualsExceptionsURL = `${environment.budgetBaseUrl}participant-actuals-exceptions/`;
  static getforecastLockDateByFyYearURL = `${environment.budgetBaseUrl}forecast-lock-date/financial-year/`;
  static postForecastLockDateURL = `${environment.budgetBaseUrl}forecast-lock-date/`;
  static postParticipantForecastExceptionsURL = `${environment.budgetBaseUrl}participant-forecast-exceptions/`;
  static getparticipantForecastExceptionsByFyYearParticipantURL = `${environment.budgetBaseUrl}participant-forecast-exceptions/financial-year/`;
  static getFinancialYearsURL = `${environment.budgetBaseUrl}forecast-chart-accounts/financial-years`;
  static postActualSettingURL = `${environment.budgetBaseUrl}participant-actuals-exceptions/`;

}
export default environment;